import React, { useState } from 'react';
import MediaUpload from '../../mediaUpload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { UploadProgress } from '../ImageGallery.styled';
import { IImageProps } from './types';
import styles from './Image.module.css';

export const Image: React.FC<IImageProps> = ({
  id,
  url,
  selected,
  allowDelete,
  onSelect,
  onDelete,
  onUpload,
}) => {
  const [uploadProgress, setUploadProgress] = useState<number>(-1);

  return (
    <>
      <div className="position-relative">
        {selected && (
          <div className={styles.buttonContainer}>
            {onUpload && (
              <MediaUpload
                id={id}
                className={`btn btn-info btn-sm ${styles.actionButton}`}
                url="/api/themes/welcomePageImage"
                onChange={(field, mediaId) => {
                  onUpload(mediaId);
                  setUploadProgress(-1);
                }}
                onUploadProgress={setUploadProgress}
              >
                <FontAwesomeIcon icon="upload" />
              </MediaUpload>
            )}
            {allowDelete && onDelete && (
              <Button
                className={`ml-1 ${styles.actionButton}`}
                type="button"
                variant="danger"
                size="sm"
                onClick={onDelete}
              >
                <FontAwesomeIcon icon="times" />
              </Button>
            )}
          </div>
        )}
      </div>
      <img
        className={styles.image}
        src={url}
        alt="Welcome"
        onClick={onSelect}
      />
      <UploadProgress progress={uploadProgress} />
    </>
  );
};
